module.exports = __webpack_public_path__ + "static/media/upload.a65f0712.svg";